module.exports = __webpack_public_path__ + "img/Pacientes_de_Alta_Complexidade.de1062a5.jpg";